import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const MembershipApplicationContent = lazy(() => import('./MembershipApplicationContent'));



const MembershipApplication = () => {
    return (
        <Suspense fallback={<DefaultLoader />}>
            <MembershipApplicationContent />
        </Suspense>
    );
};

export default MembershipApplication;